import styled from 'styled-components'

export default styled.div`
  background: #fff0e2;
`
